import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import utils from 'helpers/utils';

const StyledSection = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--section-gap': props.theme.layout(props.$gap)
    };

    return utils.styleProps(attr, vars);
  })`
  &.Section {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    overflow: hidden;
    column-gap: ${props => props.$css.$var('--section-gap', false)};
    row-gap: ${props => props.$css.$var('--section-gap', false)};
  }
  
  ${ComponentStyles}
`;

StyledSection.propTypes = {
  theme: PropTypes.object
};

export default StyledSection;
